// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// const base_url = 'http://localhost:3000/';
// const base_url = 'https://make-shaadi.herokuapp.com/';
const base_url = 'https://13.126.223.12.nip.io/';

export const environment = {
  production: false,
  api_url: `${base_url}api/v1/`
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
